export function arrayFindLastIndex<T>(
    array: readonly T[],
    predicate: (value: T, index: number, obj: readonly T[]) => boolean,
): number {
    let arrLength = array.length;

    while (arrLength--) {
        const arrayElement = array[arrLength];

        if (
            arrayElement !== undefined &&
            predicate(arrayElement, arrLength, array)
        )
            return arrLength;
    }

    return -1;
}
